export interface CashOnDeliveryFinalize {
    taskID: string;
    totalAmountFromPayment: number;
}
